import { useState } from "react";
import { X } from "lucide-react";
import Layout from "@/components/Layout";
import { galleryImages } from "@/data/content";
import { useLang } from "@/context/LanguageContext";

export default function GalleryPage() {
  const { t } = useLang();
  const [active, setActive] = useState(null);

  return (
    <Layout>
      <section className="container-sv pt-24 pb-12">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-8 h-px bg-neon-pink" style={{ background: "var(--sv-pink)" }} />
          <span className="font-display uppercase tracking-[0.35em] text-[10px] text-white/60">
            Aftermovie · Photos
          </span>
        </div>
        <h1 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tight leading-[0.92]" data-testid="gallery-page-title">
          <span className="text-white">Gallery</span>
        </h1>
        <p className="mt-5 text-white/65 font-body text-lg max-w-xl">
          {t.pages.gallery.subtitle}
        </p>
      </section>

      <section className="container-sv pb-32">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {galleryImages.map((img, i) => (
            <button
              key={i}
              onClick={() => setActive(img)}
              data-testid={`gallery-image-${i}`}
              className={`relative overflow-hidden rounded-xl group ${
                i % 5 === 0 ? "md:col-span-2 md:row-span-2 aspect-square" : "aspect-square"
              }`}
              style={i % 5 === 0 ? { gridRowEnd: "span 2" } : {}}
            >
              <img
                src={img}
                alt=""
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors" />
              <div className="absolute top-3 left-3 font-display text-[9px] tracking-[0.3em] uppercase text-white/0 group-hover:text-white/80 transition-colors">
                0{i + 1}
              </div>
            </button>
          ))}
        </div>
      </section>

      {/* Lightbox */}
      {active && (
        <div
          className="fixed inset-0 z-[60] bg-black/95 backdrop-blur-xl flex items-center justify-center p-6"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-white hover:bg-white/20"
            onClick={() => setActive(null)}
            aria-label="Close"
            data-testid="gallery-lightbox-close"
          >
            <X className="w-5 h-5" />
          </button>
          <img
            src={active}
            alt=""
            className="max-h-[88vh] max-w-[92vw] object-contain rounded-2xl"
          />
        </div>
      )}
    </Layout>
  );
}
